import { ModalContext, ModalContextProvider, useModalContext } from 'utils/contexts/modal';
import { ProjectLabel } from '../types';

export enum MODAL_NAMES {
  ADD_LOCALE = 'ADD_LOCALE',
  WA_LOCALE = 'WA_LOCALE',
  ADD_NEW_LABEL = 'ADD_NEW_LABEL',
  CONFIRM_DISABLE_ANON_USER_TRACKING = 'CONFIRM_DISABLE_ANON_USER_TRACKING',
  DELETE_LABEL = 'DELETE_LABEL',
  DELETE_LOCALE = 'DELETE_LOCALE',
  EDIT_LABEL = 'EDIT_LABEL',
  REMOVE_LOGO = 'REMOVE_LOGO',
  SET_DEFAULT_LOCALE = 'SET_DEFAULT_LOCALE',
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
}

export type ConfirmDisableAnonUserTrackingPayload = number;
export type DeleteLabelPayload = ProjectLabel;
export type DeleteLocalePayload = string;
export type EditLabelPayload = ProjectLabel;
export type SetDefaultLocalePayload = string;
export type EditLocalePayload = {
  locale: string;
  language: string | undefined;
};

export type ModalStatePayload =
  | ConfirmDisableAnonUserTrackingPayload
  | DeleteLabelPayload
  | DeleteLocalePayload
  | EditLabelPayload
  | SetDefaultLocalePayload
  | EditLocalePayload;

export type ModalState<T = ModalStatePayload> = {
  name: MODAL_NAMES;
  payload?: T;
};

export type ModalContextState<T = ModalStatePayload> = {
  showModal: (modalState: ModalState<T>) => void;
  hideModal: () => void;
  modalState: ModalState<T> | null;
};

export const useProjectSettingsModalsContext = <T = ModalStatePayload>() =>
  useModalContext<ModalState<T>>();

export const ProjectSettingsModalsContext = ModalContext;
export const ProjectSettingsModalsContextProvider = ModalContextProvider;
